import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component } from 'preact';
import { currencyFormat } from '../../../util/Formatter';
export class BidAmount extends Component {
    render() {
        return (_jsxs("div", Object.assign({ class: "level is-mobile" }, { children: [_jsx("div", Object.assign({ className: "level-item w50 has-text-centered" }, { children: _jsxs("div", { children: [_jsx("p", Object.assign({ class: "title is-size-7" }, { children: "\u5373\u6C7A\u91D1\u984D" }), void 0),
                            _jsx("p", Object.assign({ class: "subtitle is-size-6 has-text-weight-bold is-fonttype-roman" }, { children: currencyFormat(this.decisionPrice(), "-") }), void 0)] }, void 0) }), void 0),
                _jsx("div", Object.assign({ className: "level-item w50 has-text-centered" }, { children: _jsxs("div", { children: [_jsx("p", Object.assign({ class: "title is-size-7" }, { children: "\u73FE\u5728\u306E\u91D1\u984D" }), void 0),
                            _jsx("p", Object.assign({ class: "subtitle is-size-6 has-text-weight-bold is-fonttype-roman" }, { children: currencyFormat(this.maxBidAmount(), "-") }), void 0)] }, void 0) }), void 0)] }), void 0));
    }
    maxBidAmount() {
        const bids = this.props.auction.bids ?? [];
        const bidAmounts = bids.map(m => m.amount);
        return bidAmounts.length > 0 ? Math.max(...bidAmounts) : 0;
    }
    decisionPrice() {
        return this.props.auction.decisionPrice ?? 0;
    }
}
